import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Parcel from 'single-spa-react/parcel'; // eslint-disable-line
import { publishErrorNotification } from '@nbx/frontend-helpers/publish';

const microapps = window.MICROFRONTENDS_CONFIG;

const Widget = ({ widget, parcelName, ...props }) => {
  const { t } = useTranslation();

  const getWidgetParcel = () => {
    return new Promise((resolve, reject) => {
      const parcelURL = microapps?.widgets[widget];
      if (!parcelURL) reject(new Error(`Invalid widget selected, ${widget}. Abandoning Parcel load.`));
      const { PLATFORM } = window;
      let remoteEntry = `${parcelURL}/remoteEntry.js`;
      if (PLATFORM !== 'web') remoteEntry = `/${parcelURL}.remoteEntry.js`;
      let container;
      // eslint-disable-next-line no-promise-executor-return
      return new Promise((resolveModule, rejectModule) => {
        const element = document.createElement('script');
        element.src = remoteEntry;
        element.type = 'text/javascript';
        element.async = true;
        element.onload = async () => {
          await __webpack_init_sharing__('default'); // eslint-disable-line
          container = window[widget];
          await container.init(__webpack_share_scopes__.default); // eslint-disable-line
          const factory = await window[widget].get(parcelName ?? './app');
          const Module = factory();
          resolveModule(Module);
        };
        element.onerror = caughtError => {
          rejectModule(caughtError);
        };
        document.head.appendChild(element);
      })
        .then(imported => {
          resolve(imported.Parcel);
        })
        .catch(err => {
          if (typeof props.closeModal === 'function') {
            publishErrorNotification({ message: props.failureMessage ?? t('error_title_generic') });
            props.closeModal();
          }
          console.error('Widget failed to load:', err);
          reject(err);
        });
    });
  };

  return <Parcel config={getWidgetParcel} mountParcel={window.MOUNT_ROOT_PARCEL} {...props} />;
};

Widget.propTypes = {
  widget: PropTypes.string.isRequired,
  parcelName: PropTypes.string,
  failureMessage: PropTypes.string,
  closeModal: PropTypes.func // for Widgets that are modals
};

Widget.defaultProps = {
  parcelName: undefined,
  failureMessage: null,
  closeModal: null
};

export default Widget;
